import {styled} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

const getTriangleStyles = (size: any[], color: any, direction: string) => {
  let height = 0;
  let width = 0;
  let styleObj: any = {
    height: 0,
    width: 0,
  };

  width = size[0];
  height = size.pop();

  let foregroundColor = color;
  let backgroundColor = 'transparent';
  // if (length(color) == 2) {
  //   backgroundColor: nth(color, 2);
  // }

  if (
    direction == 'up' ||
    direction == 'down' ||
    direction == 'right' ||
    direction == 'left'
  ) {
    width = width / 2;

    if (direction == 'up') {
      styleObj['borderLeft'] = `${width}px solid ${backgroundColor}`;
      styleObj['borderRight'] = `${width}px solid ${backgroundColor}`;
      styleObj['borderBottom'] = `${height}px solid ${foregroundColor}`;
    } else if (direction == 'right') {
      styleObj['borderTop'] = `${width}px solid ${backgroundColor}`;
      styleObj['borderBottom'] = `${width}px solid ${backgroundColor}`;
      styleObj['borderLeft'] = `${height}px solid ${foregroundColor}`;
    } else if (direction == 'down') {
      styleObj['borderLeft'] = `${width}px solid ${backgroundColor}`;
      styleObj['borderRight'] = `${width}px solid ${backgroundColor}`;
      styleObj['borderTop'] = `${height}px solid ${foregroundColor}`;
    } else if (direction == 'left') {
      styleObj['borderTop'] = `${width}px solid ${backgroundColor}`;
      styleObj['borderBottom'] = `${width}px solid ${backgroundColor}`;
      styleObj['borderRight'] = `${height}px solid ${foregroundColor}`;
    }
  } else if (direction == 'up-right' || direction == 'up-left') {
    styleObj['borderTop'] = `${height}px solid ${foregroundColor}`;

    if (direction == 'up-right') {
      styleObj['borderLeft'] = `${width}px solid ${backgroundColor}`;
    } else if (direction == 'up-left') {
      styleObj['borderRight'] = `${width}px solid ${backgroundColor}`;
    }
  } else if (direction == 'down-right' || direction == 'down-left') {
    styleObj['borderBottom'] = `${height}px solid ${foregroundColor}`;

    if (direction == 'down-right') {
      styleObj['borderLeft'] = `${width}px solid ${backgroundColor}`;
    } else if (direction == 'down-left') {
      styleObj['borderRight'] = `${width}px solid ${backgroundColor}`;
    }
  } else if (direction == 'inset-up') {
    styleObj['border-width'] = `${height} ${width}`;
    styleObj['border-style'] = `solid`;
    styleObj[
      'border-color'
    ] = `${backgroundColor} ${backgroundColor} ${foregroundColor}`;
  } else if (direction == 'inset-down') {
    styleObj['border-width'] = `${height} ${width}`;
    styleObj['border-style'] = `solid`;
    styleObj[
      'border-color'
    ] = `${foregroundColor} ${backgroundColor} ${backgroundColor}`;
  } else if (direction == 'inset-right') {
    styleObj['border-width'] = `${width} ${height}`;
    styleObj['border-style'] = `solid`;
    styleObj[
      'border-color'
    ] = `${backgroundColor} ${backgroundColor} ${backgroundColor} ${foregroundColor}`;
  } else if (direction == 'inset-left') {
    styleObj['border-width'] = `${width} ${height}`;
    styleObj['border-style'] = `solid`;
    styleObj[
      'border-color'
    ] = `${backgroundColor} ${foregroundColor} ${backgroundColor} ${backgroundColor}`;
  }
  return styleObj;
};

const Ribbon = styled('div')<any>(props => ({
  color: '#fff',
  width: '160px',
  fontSize: props.theme.typography.pxToRem(9),
  textTransform: 'uppercase',
  lineHeight: '15px',
  background: `${props.theme.palette.secondary.main}b3`,
  borderBottomLeftRadius: '30px',
  borderTopLeftRadius: '30px',
  letterSpacing: '1px',
  // '&:before': {
  //   content: "''",
  //   position: 'absolute',
  //   borderBottomColor: props.theme.palette.secondary.dark,
  //   top: '-12px',
  //   right: '0px',
  //   ...getTriangleStyles([12], props.theme.palette.secondary.dark, 'down-left'),
  // },
  // '&:after': {
  //   content: "''",
  //   position: 'absolute',
  //   borderRightColor: props.theme.palette.secondary.main,
  //   left: '-20px',
  //   top: '0',
  //   ...getTriangleStyles(
  //     [50, 20],
  //     `${props.theme.palette.secondary.main}b3`,
  //     'left'
  //   ),
  // },
  padding: '15px 15px 10px 15px',
  fontWeight: 700,
  textAlign: 'left',
  ':hover': {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}));

const Logo = styled(Image)<any>({
  zIndex: 10,
  borderRadius: '15px',
});
const Component = (props: any) => {
  const isLarge = useIsLargeDevice('xl');

  return (
    <>
      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: props.isAboveMobile ? 'column' : 'row-reverse',
          gap: '12px',
          justifyContent: props.isAboveMobile ? 'center' : 'space-between',
          alignItems: 'center',
        }}
      >
        {props.imgUrl && (
          <Logo src={props.imgUrl} alt={props.label} height={45} width={130} />
        )}
        <Ribbon
          style={{
            borderBottomLeftRadius: props.isAboveMobile ? '30px' : '0px',
            borderTopLeftRadius: props.isAboveMobile ? '30px' : '0px',
            borderBottomRightRadius: props.isAboveMobile ? '0px' : '30px',
            borderTopRightRadius: props.isAboveMobile ? '0px' : '30px',
          }}
          className="ribbon-left"
          isLarge={isLarge}
          {...props}
        >
          <span>
            {props.label}{' '}
            <span
              style={{
                fontSize: '10px',
                verticalAlign: 'middle',
                fontFamily: 'sans-serif',
              }}
            >
              {'>'}
            </span>
          </span>
        </Ribbon>
      </div>
    </>
  );
};

export default Component;
